export class ThemeInfo {
  cssText: string;
  logoUrl: string;
  constructor(cssText: string, logoUrl: string) {
    this.cssText = cssText;
    this.logoUrl = logoUrl;
  }
}
